import { render, staticRenderFns } from "./ReturnUserModule.vue?vue&type=template&id=64005892&lang=pug"
import script from "./ReturnUserModule.vue?vue&type=script&lang=js"
export * from "./ReturnUserModule.vue?vue&type=script&lang=js"
import style0 from "./ReturnUserModule.vue?vue&type=style&index=0&id=64005892&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports